// Web mock for react-native-ratings
import React, { useState } from 'react';
import { View, TouchableOpacity, Text, StyleSheet } from 'react-native';

interface AirbnbRatingProps {
  count?: number;
  defaultRating?: number;
  onFinishRating?: (rating: number) => void;
  size?: number;
  showRating?: boolean;
  isDisabled?: boolean;
  selectedColor?: string;
  unSelectedColor?: string;
  reviewColor?: string;
  reviewSize?: number;
  reviews?: string[];
  starContainerStyle?: any;
  ratingContainerStyle?: any;
}

export const AirbnbRating: React.FC<AirbnbRatingProps> = ({
  count = 5,
  defaultRating = 3,
  onFinishRating,
  size = 40,
  showRating = true,
  isDisabled = false,
  selectedColor = '#FFD700',
  unSelectedColor = '#BDC3C7',
  reviews = ['Terrible', 'Bad', 'OK', 'Good', 'Great'],
}) => {
  const [rating, setRating] = useState(defaultRating);

  const handlePress = (index: number) => {
    if (isDisabled) return;
    const newRating = index + 1;
    setRating(newRating);
    onFinishRating?.(newRating);
  };

  return (
    <View style={styles.container}>
      {showRating && (
        <Text style={styles.reviewText}>
          {reviews[Math.min(rating - 1, reviews.length - 1)] || ''}
        </Text>
      )}
      <View style={styles.starsContainer}>
        {Array.from({ length: count }, (_, index) => (
          <TouchableOpacity
            key={index}
            onPress={() => handlePress(index)}
            disabled={isDisabled}
          >
            <Text
              style={{
                fontSize: size,
                color: index < rating ? selectedColor : unSelectedColor,
                marginHorizontal: 2,
              }}
            >
              ★
            </Text>
          </TouchableOpacity>
        ))}
      </View>
    </View>
  );
};

interface RatingProps {
  type?: string;
  ratingCount?: number;
  imageSize?: number;
  startingValue?: number;
  onFinishRating?: (rating: number) => void;
  readonly?: boolean;
  style?: any;
  ratingColor?: string;
  ratingBackgroundColor?: string;
  tintColor?: string;
}

export const Rating: React.FC<RatingProps> = ({
  ratingCount = 5,
  startingValue = 0,
  imageSize = 40,
  onFinishRating,
  readonly = false,
  ratingColor = '#FFD700',
  ratingBackgroundColor = '#BDC3C7',
}) => {
  return (
    <AirbnbRating
      count={ratingCount}
      defaultRating={startingValue}
      size={imageSize}
      onFinishRating={onFinishRating}
      isDisabled={readonly}
      selectedColor={ratingColor}
      unSelectedColor={ratingBackgroundColor}
      showRating={false}
    />
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
  },
  starsContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  reviewText: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 8,
  },
});

export default { AirbnbRating, Rating };
